import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ds';
import { ChevronRight } from 'lucide-react';
import { PipelineTiles, RecentRequestsStrip } from '@/components/contracting';
import { countActiveAppointments } from '@/lib/contracting/statusMapping';

/**
 * AgencyContractingPipeline — thin orchestrator that composes the shared
 * PipelineTiles + RecentRequestsStrip around an agency-scoped Card header.
 * All tile-rendering, badge colouring, and "Most Recent" layout are owned
 * by the shared contracting components so agent and agency views cannot
 * drift.
 */
const agencyMetaFormatter = (r) =>
  [r?.agent_name, r?.level_name].filter(Boolean).join(' · ');

export const AgencyContractingPipeline = ({ requests = [], appointments = [], agencyId }) => {
  const activatedCount = countActiveAppointments(appointments);
  const totalRequests = requests.length;

  return (
    <Card
      title="Contracting Pipeline"
      description={`${totalRequests} contract request${totalRequests === 1 ? '' : 's'} · ${activatedCount} active writing number${activatedCount === 1 ? '' : 's'}`}
      headerActions={
        <Link
          to={`/requests?agency=${agencyId || ''}`}
          className="text-xs font-medium hover:underline flex items-center gap-1"
          style={{ color: 'var(--kr-navy-700)' }}
          data-testid="agency-pipeline-see-all"
        >
          See all requests <ChevronRight size={13} />
        </Link>
      }
      testId="agency-contracting-pipeline"
    >
      <PipelineTiles requests={requests} appointments={appointments} testIdPrefix="agency-pipeline" />
      <RecentRequestsStrip
        requests={requests}
        testIdPrefix="agency-recent-request"
        metaFormatter={agencyMetaFormatter}
      />
    </Card>
  );
};

export default AgencyContractingPipeline;
